import { render, staticRenderFns } from "./SelectedFilter.vue?vue&type=template&id=0a2ca558&scoped=true&"
import script from "./SelectedFilter.vue?vue&type=script&lang=js&"
export * from "./SelectedFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ca558",
  null
  
)

export default component.exports